// TODO: refactor with imports
import currencySymbol from '@entegral/helpers.formatters/price/currency-symbol';
import currencyPosition from '@entegral/helpers.formatters/price/currency-position';

export function shortPrice(value, currencyCode, currencyDelimiter=``) {
  if (!value) return '';

  value = parseInt(value);

  if (isNaN(value)) return '';

  let formatted;
  let suffix;
  let symbol = currencySymbol(currencyCode);
  let position = currencyPosition(currencyCode);

  if (value < 1000) {
    formatted = value;
    suffix = '';
  } else if (value < 1000000) {
    suffix = 'K';
    formatted = value / 1000;
  } else {
    suffix = 'M';
    formatted = value / 1000000;
  }

  let precision = formatted / 100 < 1 ? 1 : 0;

  formatted = formatted.toFixed(precision);
  formatted = formatted.replace('.0', '');

  if (position === 'before') return `${symbol}${currencyDelimiter}${formatted}${suffix}`;
  return `${formatted}${suffix}${currencyDelimiter}${symbol}`;
}
